/* Foundry theme — global scripts */
(function () {
  'use strict';

  var T = window.theme = window.theme || {};
  T.loaded = true;
  T.routes = T.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', search: '/search', predictive: '/search/suggest', recommendations: '/recommendations/products' };
  T.strings = T.strings || {};
  T.settings = T.settings || {};

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); };
  function once(el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function sstore(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function rootUrl() { var r = T.routes.root || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  T.$ = $; T.$$ = $$; T.once = once;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    /* Markets: when the buyer sees a different currency from the store's own, the store's money format
       (e.g. "£{{amount}}") would show the wrong symbol, so format with the buyer's currency instead. */
    if (!format && T.currency && T.shopCurrency && T.currency !== T.shopCurrency) {
      try { return new Intl.NumberFormat(T.locale || document.documentElement.lang || undefined, { style: 'currency', currency: T.currency }).format(cents / 100); } catch (e) {}
    }
    format = format || T.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, p, th, dec) {
      th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(re); if (!m) return format;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }
  T.formatMoney = formatMoney;
  function rate() { try { return parseFloat(window.Shopify.currency.rate) || 1; } catch (e) { return 1; } }

  function toast(msg) {
    var t = $('.toast') || document.body.appendChild(Object.assign(document.createElement('div'), { className: 'toast', role: 'status' }));
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  T.toast = toast;

  /* ---------- Panels (drawers, modals, sheets) ---------- */
  var stack = [];
  function focusables(el) { return $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; }); }
  function openPanel(el, opener) {
    if (!el || el.classList.contains('is-open')) return;
    // Pop-ups inside sections are moved to <body> so sticky columns and stacking can't trap them
    if (el.classList.contains('modal') && el.parentElement !== document.body && !el.querySelector('form')) document.body.appendChild(el);
    el._opener = opener || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll');
    stack.push(el);
    var f = $('[data-autofocus]', el) || $('.drawer__close, .icon-btn', el);
    setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 80);
    el.dispatchEvent(new CustomEvent('panel:open', { bubbles: true }));
  }
  function closePanel(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$('.drawer__sheet.is-open', el).forEach(closeSheet);
    stack = stack.filter(function (x) { return x !== el; });
    if (!stack.length) { document.body.classList.remove('no-scroll'); document.documentElement.classList.remove('no-scroll'); }
    if (el._opener && el._opener.focus) el._opener.focus({ preventScroll: true });
    el.dispatchEvent(new CustomEvent('panel:close', { bubbles: true }));
  }
  function openSheet(sh) { sh.classList.add('is-open'); sh.closest('.drawer__panel').classList.add('has-sheet'); var i = $('input, textarea', sh); if (i) setTimeout(function () { i.focus(); }, 300); }
  function closeSheet(sh) { sh.classList.remove('is-open'); var p = sh.closest('.drawer__panel'); if (p) p.classList.remove('has-sheet'); }
  T.openPanel = openPanel; T.closePanel = closePanel;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-open]');
    if (o) {
      var target = document.getElementById(o.getAttribute('data-open'));
      if (target) { e.preventDefault(); if (target.classList.contains('is-open')) closePanel(target); else openPanel(target, o); return; }
    }
    var sh = t.closest('[data-sheet]');
    if (sh) { e.preventDefault(); var s = document.getElementById(sh.getAttribute('data-sheet')); if (s) openSheet(s); return; }
    var shc = t.closest('[data-sheet-close]');
    if (shc) { e.preventDefault(); closeSheet(shc.closest('.drawer__sheet')); return; }
    var c = t.closest('[data-close]');
    if (c) { var p = c.closest('.drawer, .modal'); if (p) { e.preventDefault(); closePanel(p); } return; }
    var co = t.closest('[data-cart-open]');
    if (co && T.cartType !== 'page' && $('#CartDrawer') && !document.body.classList.contains('template-cart')) { e.preventDefault(); openPanel($('#CartDrawer'), co); }
  });
  document.addEventListener('keydown', function (e) {
    var top = stack[stack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { var sh = $('.drawer__sheet.is-open', top); if (sh) closeSheet(sh); else closePanel(top); }
    if (e.key === 'Tab') {
      var f = focusables(top); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Swipe down to close bottom sheets */
  function initSwipe(drawer) {
    if (!once(drawer, 'swipe')) return;
    var panel = $('.drawer__panel', drawer), startY = 0, dy = 0, dragging = false;
    function isSheet() { return drawer.classList.contains('drawer--bottom') || (drawer.classList.contains('drawer--auto') && window.innerWidth < 750); }
    on(drawer, 'touchstart', function (e) {
      if (!isSheet()) return;
      var h = e.target.closest('.drawer__grip, .drawer__head');
      var body = $('.drawer__body', drawer);
      if (!h && !(body && body.contains(e.target) && body.scrollTop <= 0)) return;
      startY = e.touches[0].clientY; dy = 0; dragging = true;
    }, { passive: true });
    on(drawer, 'touchmove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      if (dy > 4) { drawer.classList.add('is-dragging'); panel.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    on(drawer, 'touchend', function () {
      if (!dragging) return;
      dragging = false; drawer.classList.remove('is-dragging'); panel.style.transform = '';
      if (dy > Math.min(140, panel.offsetHeight * .25)) closePanel(drawer);
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var wrap = $('.section-header');
    if (!wrap || !once(wrap, 'ready')) return;
    var hdr = $('.hdr', wrap);
    var mode = hdr.getAttribute('data-sticky') || 'none';
    var transparent = !!$('#MainContent > .shopify-section:first-child [data-transparent-header]');
    var last = window.scrollY, ticking = false;
    function setH() { document.documentElement.style.setProperty('--th-h', hdr.offsetHeight + 'px'); }
    setH(); on(window, 'resize', debounce(setH, 150));
    if (mode !== 'none' && !transparent) wrap.classList.add('is-sticky');
    function onScroll() {
      ticking = false;
      var y = window.scrollY, h = hdr.offsetHeight;
      var past = y > h + 20;
      if (mode === 'none') {
        if (transparent) wrap.classList.toggle('is-scrolled', false);
        return;
      }
      wrap.classList.toggle('is-scrolled', y > 4 && (!transparent || past));
      if (transparent) wrap.classList.toggle('is-fixed', past);
      if (mode === 'scroll-up') wrap.classList.toggle('is-hidden', y > last && y > h * 2 && !document.body.classList.contains('no-scroll'));
      last = y;
    }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ---------- Announcement slider ---------- */
  function initAnnouncement(el) {
    if (!once(el, 'ready')) return;
    var slides = $$('.announce__slides > *', el); if (slides.length < 2) return;
    var i = 0, ms = (parseInt(el.getAttribute('data-speed'), 10) || 5) * 1000, t;
    function go(n) { slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); }
    function play() { clearInterval(t); t = setInterval(function () { go(i + 1); }, ms); }
    on($('[data-prev]', el), 'click', function () { go(i - 1); play(); });
    on($('[data-next]', el), 'click', function () { go(i + 1); play(); });
    play();
  }

  /* ---------- Search ---------- */
  function initSearch() {
    var panel = $('#SearchDrawer'); if (!panel || !once(panel, 'ready')) return;
    var input = $('input[name="q"]', panel), results = $('[data-ps-results]', panel), start = $('[data-ps-start]', panel);
    var words = (panel.getAttribute('data-placeholders') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var base = input.getAttribute('placeholder') || '';
    var tw;
    function typewriter() {
      if (!words.length) return;
      var w = 0, c = 0, del = false;
      clearInterval(tw);
      tw = setInterval(function () {
        if (input.value) return;
        var word = words[w];
        c += del ? -1 : 1;
        input.setAttribute('placeholder', base + ' ' + word.slice(0, c));
        if (!del && c === word.length) { del = true; c += 6; }
        if (del && c <= 0) { del = false; w = (w + 1) % words.length; c = 0; }
      }, 90);
    }
    on(panel, 'panel:open', typewriter);
    on(panel, 'panel:close', function () { clearInterval(tw); input.setAttribute('placeholder', base); });
    if (panel.getAttribute('data-predictive') !== 'true' || !results) return;
    var ctrl;
    on(input, 'input', debounce(function () {
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; results.hidden = true; if (start) start.hidden = false; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = T.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,query&resources[limit]=' + (panel.getAttribute('data-limit') || 6) + '&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var inner = $('[data-ps-inner]', d);
        results.innerHTML = inner ? inner.innerHTML : '';
        results.hidden = false; if (start) start.hidden = true;
      }).catch(function () {});
    }, 220));
  }

  /* ---------- Cart ---------- */
  var hyOwn = false;
  function postJSON(url, body) {
    hyOwn = true;
    var req; try { req = fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); } finally { hyOwn = false; }
    return req
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || T.strings.error || 'Error'); return j; }); });
  }
  /* Apps that add to cart on their own (e.g. Kaching Bundles): refresh the cart count and open the cart drawer */
  (function () {
    if (window.__hyCartHook) return; window.__hyCartHook = 1;
    var isAdd = function (u) { return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(u || '').split('#')[0]); };
    var t = 0, onAdd = function () { clearTimeout(t); t = setTimeout(function () { if (T.Cart && T.Cart.refresh) T.Cart.refresh(T.cartType !== 'page' && !document.querySelector('[data-cart-page]')); }, 120); };
    if (window.fetch) {
      var f = window.fetch;
      window.fetch = function (input) {
        var own = hyOwn, url = typeof input === 'string' ? input : (input && input.url) || '', p = f.apply(this, arguments);
        if (!own && isAdd(url)) p.then(function (r) { if (r && r.ok) onAdd(); }, function () {});
        return p;
      };
    }
    var X = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (X) {
      var open = X.open, send = X.send;
      X.open = function (m, u) { this.__hyAdd = isAdd(u); return open.apply(this, arguments); };
      X.send = function () { if (this.__hyAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) onAdd(); }); return send.apply(this, arguments); };
    }
  })();
  var Cart = T.Cart = {
    data: null,
    get: function () { return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { Cart.data = c; return c; }); },
    refresh: function (open) {
      var drawer = $('#CartDrawer');
      var jobs = [Cart.get()];
      if (drawer) jobs.push(fetch(rootUrl() + '?section_id=cart-drawer').then(function (r) { return r.text(); }));
      return Promise.all(jobs).then(function (out) {
        var cart = out[0];
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
        if (drawer && out[1]) {
          var d = new DOMParser().parseFromString(out[1], 'text/html');
          var fresh = $('[data-cart-inner]', d), inner = $('[data-cart-inner]', drawer);
          if (fresh && inner) { inner.innerHTML = fresh.innerHTML; initCartUI(drawer); }
          if (open) openPanel(drawer);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
    },
    add: function (items, opener) {
      return postJSON(T.routes.cartAdd + '.js', { items: items }).then(function () {
        return Cart.syncGift().then(function () {
          if (T.cartType === 'page' || !$('#CartDrawer')) { window.location.href = T.routes.cart; return; }
          return Cart.refresh(true);
        });
      });
    },
    change: function (key, qty) {
      var box = $('#CartDrawer [data-cart-inner]') || $('[data-cart-page]');
      if (box) box.classList.add('is-loading');
      return postJSON(T.routes.cartChange + '.js', { id: key, quantity: Math.max(0, qty) })
        .then(function () { return Cart.syncGift(); })
        .then(function () { if ($('[data-cart-page]')) { window.location.reload(); return; } return Cart.refresh(false); })
        .catch(function (err) { toast(err.message); })
        .then(function () { if (box) box.classList.remove('is-loading'); });
    },
    update: function (body) {
      return postJSON(T.routes.cartUpdate + '.js', body).then(function () { if ($('[data-cart-page]')) { window.location.reload(); return; } return Cart.refresh(false); });
    },
    /* Free gift: added when the goal is reached, removed when it isn't */
    syncGift: function () {
      var g = T.settings.gift;
      if (!g || !g.variant) return Promise.resolve();
      return Cart.get().then(function (cart) {
        var giftLines = cart.items.filter(function (i) { return i.variant_id === g.variant; });
        var others = cart.items.filter(function (i) { return i.variant_id !== g.variant; });
        var total = others.reduce(function (s, i) { return s + i.final_line_price; }, 0);
        var count = others.reduce(function (s, i) { return s + i.quantity; }, 0);
        var ok = g.rule === 'quantity' ? count >= g.quantity : total >= g.amount * 100 * rate();
        if (ok && !giftLines.length) return postJSON(T.routes.cartAdd + '.js', { items: [{ id: g.variant, quantity: 1, properties: { _free_gift: 'true' } }] }).catch(function () {});
        if (!ok && giftLines.length) return postJSON(T.routes.cartChange + '.js', { id: giftLines[0].key, quantity: 0 });
        if (ok && giftLines[0] && giftLines[0].quantity > 1) return postJSON(T.routes.cartChange + '.js', { id: giftLines[0].key, quantity: 1 });
      });
    }
  };

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) { e.preventDefault(); Cart.change(q.getAttribute('data-cart-qty'), parseInt(q.getAttribute('data-qty'), 10) || 0); return; }
    var add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      var sel = add.closest('[data-addon]') && $('select', add.closest('[data-addon]'));
      var id = sel ? sel.value : add.getAttribute('data-add-variant');
      add.classList.add('is-loading');
      Cart.add([{ id: parseInt(id, 10), quantity: 1 }]).catch(function (err) { toast(err.message); }).then(function () { add.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-cart-input]');
    if (i) { Cart.change(i.getAttribute('data-cart-input'), parseInt(i.value, 10) || 0); return; }
    var gw = e.target.closest('[data-gift-wrap]');
    if (gw) {
      var vid = parseInt(gw.getAttribute('data-gift-wrap'), 10);
      if (gw.checked) Cart.add([{ id: vid, quantity: 1 }]).catch(function (err) { toast(err.message); });
      else Cart.get().then(function (c) { var l = c.items.filter(function (x) { return x.variant_id === vid; })[0]; if (l) Cart.change(l.key, 0); });
      return;
    }
    var terms = e.target.closest('[data-terms]');
    if (terms) { sstore('foundry-terms', terms.checked ? '1' : ''); gateCheckout(); return; }
    var s = e.target.closest('[data-sort]');
    if (s) { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); return; }
    var a = e.target.closest('[data-autosubmit]');
    if (a && a.form) a.form.submit();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-discount-form]')) {
      e.preventDefault();
      var code = $('input', f).value.trim(); if (!code) return;
      var btn = $('button', f); btn.classList.add('is-loading');
      var existing = (Cart.data && Cart.data.discount_codes || []).map(function (d) { return d.code; });
      Cart.update({ discount: existing.concat([code]).join(',') }).then(function () {
        var c = Cart.data, hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        toast(hit && hit.applicable ? (T.strings.discountApplied || 'Discount applied') : (T.strings.discountInvalid || 'That code can’t be used on this cart'));
      }).catch(function (err) { toast(err.message); }).then(function () { btn.classList.remove('is-loading'); });
    }
    if (f.matches('[data-note-form]')) {
      e.preventDefault();
      var b2 = $('button[type="submit"]', f); b2.classList.add('is-loading');
      Cart.update({ note: $('textarea', f).value }).then(function () { toast(T.strings.noteSaved || 'Note saved'); }).catch(function () {}).then(function () { b2.classList.remove('is-loading'); });
    }
    if (f.matches('[data-checkout-form]') && f.querySelector('[data-terms]') && !f.querySelector('[data-terms]').checked) {
      e.preventDefault(); toast(T.strings.termsRequired || 'Please accept the terms to continue');
    }
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-code]');
    if (!rm) return;
    e.preventDefault();
    var keep = (Cart.data && Cart.data.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c !== rm.getAttribute('data-remove-code'); });
    Cart.update({ discount: keep.join(',') });
  });

  function gateCheckout() {
    $$('[data-terms]').forEach(function (t) {
      var ok = t.checked;
      var form = t.closest('form'); if (!form) return;
      $$('[name="checkout"]', form).forEach(function (b) { b.classList.toggle('is-disabled', !ok); b.setAttribute('aria-disabled', ok ? 'false' : 'true'); });
    });
  }

  var timerEnd = null;
  /* Visible scroll bar for the cart products (native bars hide on phones) */
  function initScrollHint(drawer) {
    if (!drawer || !drawer.classList.contains('has-scroll-hint')) return;
    var box = $('[data-cart-tab="cart"] .drawer__body', drawer); if (!box || box._hint) return;
    box._hint = true;
    var bar = document.createElement('div'); bar.className = 'scroll-hint'; bar.setAttribute('aria-hidden', 'true'); bar.innerHTML = '<i></i>';
    box.parentNode.insertBefore(bar, box.nextSibling);
    var thumb = bar.firstChild, th = 0;
    function upd() {
      var h = box.clientHeight, sh = box.scrollHeight, on = h > 0 && sh > h + 4;
      bar.classList.toggle('is-on', on); if (!on) return;
      bar.style.top = box.offsetTop + 'px'; bar.style.height = h + 'px';
      th = Math.max(32, Math.round((h - 8) * h / sh));
      var max = h - 8 - th, p = sh - h > 0 ? box.scrollTop / (sh - h) : 0;
      thumb.style.height = th + 'px'; thumb.style.transform = 'translateY(' + Math.round(4 + p * max) + 'px)';
    }
    on(box, 'scroll', upd, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(upd).observe(box);
    if (window.MutationObserver) new MutationObserver(function () { requestAnimationFrame(upd); }).observe(box, { childList: true, subtree: true });
    drawer._hintUpd = upd; /* the cart contents are replaced on every change, so these call the latest one */
    if (!drawer._hintBound) {
      drawer._hintBound = true;
      drawer.addEventListener('panel:open', function () { setTimeout(function () { drawer._hintUpd(); }, 60); setTimeout(function () { drawer._hintUpd(); }, 450); });
      on(window, 'resize', debounce(function () { drawer._hintUpd(); }, 100));
    }
    /* drag the bar to scroll */
    on(thumb, 'pointerdown', function (e) {
      e.preventDefault(); var y0 = e.clientY, s0 = box.scrollTop; bar.classList.add('is-drag');
      function move(ev) { var h = box.clientHeight, sh = box.scrollHeight; box.scrollTop = s0 + (ev.clientY - y0) * (sh - h) / Math.max(1, h - 8 - th); }
      function up() { bar.classList.remove('is-drag'); document.removeEventListener('pointermove', move); document.removeEventListener('pointerup', up); }
      document.addEventListener('pointermove', move); document.addEventListener('pointerup', up);
    });
    upd();
  }

  function initCartUI(root) {
    if (!root) return;
    initScrollHint(root);
    // terms state
    $$('[data-terms]', root).forEach(function (t) { t.checked = sstore('foundry-terms') === '1'; });
    gateCheckout();
    // progress bar in the shopper's currency (goals are set in the store currency)
    var r = rate();
    if (r !== 1) $$('[data-goals]', root).forEach(function (g) {
      var esc = function (x) { var d = document.createElement('div'); d.textContent = x || ''; return d.innerHTML; };
      var total = parseInt(g.getAttribute('data-total'), 10) || 0, max = 0, next = null;
      var marks = $$('[data-goal]', g);
      marks.forEach(function (m) { max = Math.max(max, (+m.getAttribute('data-goal')) * r); });
      marks.forEach(function (m) {
        var a = (+m.getAttribute('data-goal')) * r;
        m.classList.toggle('is-done', total >= a);
        if (!next && total < a) next = { a: a, l: m.getAttribute('data-label') };
      });
      var bar = $('.goals__bar', g); if (bar && max) bar.style.setProperty('--p', Math.min(100, Math.round(total * 100 / max)) + '%');
      var t = $('[data-goals-text]', g);
      if (t) t.innerHTML = next ? esc(g.getAttribute('data-text')).replace('[amount]', '<b>' + formatMoney(next.a - total) + '</b>').replace('[reward]', '<b>' + esc(next.l) + '</b>') : esc(g.getAttribute('data-done'));
    });
    // countdown
    var tm = $('[data-cart-timer]', root);
    if (tm) {
      var mins = parseInt(tm.getAttribute('data-cart-timer'), 10) || 10;
      var saved = parseInt(sstore('foundry-timer'), 10);
      if (!saved || saved < Date.now()) { saved = Date.now() + mins * 60000; sstore('foundry-timer', String(saved)); }
      timerEnd = saved;
      var out = $('b', tm);
      var tick = function () {
        var left = Math.max(0, timerEnd - Date.now());
        if (out) out.textContent = Math.floor(left / 60000) + ':' + ('0' + Math.floor(left % 60000 / 1000)).slice(-2);
        if (!left) { sstore('foundry-timer', ''); }
      };
      tick(); clearInterval(T._timer); T._timer = setInterval(tick, 1000);
    }
    // recommended add-ons (Shopify recommendations)
    var ad = $('[data-addons-auto]', root);
    if (ad && ad.getAttribute('data-product-id')) {
      fetch(T.routes.recommendations + '?product_id=' + ad.getAttribute('data-product-id') + '&limit=' + (ad.getAttribute('data-limit') || 4) + '&intent=related&section_id=cart-addons')
        .then(function (res) { return res.text(); }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html'); var inner = $('[data-addons-inner]', d);
          if (inner && inner.children.length) { ad.innerHTML = inner.innerHTML; ad.closest('.cart-block').hidden = false; }
        }).catch(function () {});
    }
    // recently viewed tab
    var rv = $('[data-recent-list]', root);
    if (rv) renderRecent(rv);
    // tabs (Cart | Recently viewed)
    $$('[data-cart-tabs] button', root).forEach(function (b) {
      on(b, 'click', function () {
        $$('[data-cart-tabs] button', root).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        $$('[data-cart-tab]', root).forEach(function (p) { p.hidden = p.getAttribute('data-cart-tab') !== b.getAttribute('data-tab'); });
      });
    });
  }

  /* ---------- Recently viewed ---------- */
  function pushRecent(handle) {
    if (!handle) return;
    var list = (store('foundry-recent') || []).filter(function (h) { return h !== handle; });
    list.unshift(handle); store('foundry-recent', list.slice(0, 12));
  }
  T.pushRecent = pushRecent;
  function renderRecent(el) {
    var list = (store('foundry-recent') || []).slice(0, parseInt(el.getAttribute('data-limit'), 10) || 6);
    if (!list.length) return;
    Promise.all(list.map(function (h) { return fetch(rootUrl() + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (products) {
        var html = products.filter(Boolean).map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          return '<a href="' + p.url + '"><span class="recent__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="200" height="250">' : '') + '</span><span><span class="citem__title">' + p.title + '</span><br><span class="citem__meta">' + formatMoney(p.price) + '</span></span></a>';
        }).join('');
        if (html) el.innerHTML = html;
      });
  }

  /* ---------- Product cards: swatches & quick add ---------- */
  function cardVariants(card) {
    if (!card._v) { try { card._v = JSON.parse($('[data-card-json]', card).textContent); } catch (e) { card._v = null; } }
    return card._v;
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-card-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('.pcard');
      $$('[data-card-swatch]', card).forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      var img = $('.pcard__media .img-1', card), src = sw.getAttribute('data-img');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      card.setAttribute('data-colour', sw.getAttribute('data-value'));
      var link = sw.getAttribute('data-url'); if (link) $$('a.pcard__media, .pcard__title', card).forEach(function (a) { a.href = link; });
      updateQuickSizes(card);
      return;
    }
    var qs = e.target.closest('[data-qa-size]');
    if (qs) {
      e.preventDefault();
      var c2 = qs.closest('.pcard'), data = cardVariants(c2); if (!data) return;
      var colour = c2.getAttribute('data-colour');
      var v = data.variants.filter(function (x) { return x.options[data.size_index] === qs.getAttribute('data-qa-size') && (data.colour_index < 0 || !colour || x.options[data.colour_index] === colour); })[0];
      if (!v) return;
      qs.classList.add('is-loading');
      Cart.add([{ id: v.id, quantity: 1 }]).then(function () { c2.classList.add('is-added'); setTimeout(function () { c2.classList.remove('is-added'); }, 900); })
        .catch(function (err) { toast(err.message); }).then(function () { qs.classList.remove('is-loading'); });
      return;
    }
    var qb = e.target.closest('[data-qa-btn]');
    if (qb) {
      e.preventDefault();
      var c3 = qb.closest('.pcard'), d3 = cardVariants(c3), qa = qb.closest('.qa');
      if (d3 && d3.size_index > -1 && qa && $('.qa__sizes', qa)) { qa.classList.toggle('is-open'); return; }
      var vid = qb.getAttribute('data-variant');
      if (!vid) { window.location.href = c3.querySelector('.pcard__title').href; return; }
      qb.classList.add('is-loading');
      Cart.add([{ id: parseInt(vid, 10), quantity: 1 }]).catch(function (err) { toast(err.message); }).then(function () { qb.classList.remove('is-loading'); });
    }
  });
  function updateQuickSizes(card) {
    var data = cardVariants(card); if (!data || data.size_index < 0) return;
    var colour = card.getAttribute('data-colour');
    $$('[data-qa-size]', card).forEach(function (b) {
      var ok = data.variants.some(function (x) { return x.available && x.options[data.size_index] === b.getAttribute('data-qa-size') && (data.colour_index < 0 || !colour || x.options[data.colour_index] === colour); });
      b.disabled = !ok;
    });
  }

  /* ---------- Animations ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function splitWords(el) {
    if (!once(el, 'split')) return;
    var n = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement('span'); w.className = 'split-w';
            var i = document.createElement('span'); i.textContent = p; i.style.setProperty('--w', n++);
            w.appendChild(i); frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') walk(child);
      });
    })(el);
  }
  function initAnimations(scope) {
    scope = scope || document;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (document.body.hasAttribute('data-anim-heading') && !reduce) $$('.sec:not([data-anim="none"]) [data-split]', scope).forEach(splitWords);
    $$('.sec .rv-stagger', scope).forEach(function (g) { $$(':scope > *', g).forEach(function (c, i) { c.style.setProperty('--i', Math.min(i, 8)); }); });
    var els = $$('.sec .rv, .sec .rv-stagger, .sec [data-split], .rv-img, .title em', scope);
    if (!io || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    els.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
    if (!T._revealGuard) {
      // Safety net: anything already on screen (or scrolled past) is always shown
      T._revealGuard = true;
      var guard = function () {
        $$('.sec .rv:not(.is-in), .sec .rv-stagger:not(.is-in), .sec [data-split]:not(.is-in), .rv-img:not(.is-in), .title em:not(.is-in)').forEach(function (e) {
          var r = e.getBoundingClientRect(); if (r.top < window.innerHeight && (r.bottom > -40 || r.top < 0)) e.classList.add('is-in');
        });
      };
      on(window, 'scroll', debounce(guard, 350), { passive: true });
      setTimeout(guard, 2000);
    }
  }
  T.initAnimations = initAnimations;

  /* ---------- Carousels ---------- */
  function initCarousel(c) {
    if (!once(c, 'carousel')) return;
    var track = $('[data-track]', c); if (!track) return;
    var dots = $$('[data-dots] span', c);
    function step() { var f = track.firstElementChild; if (!f) return 300; var g = parseFloat(getComputedStyle(track).columnGap) || 0; return f.getBoundingClientRect().width + g; }
    on($('[data-prev]', c), 'click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    on($('[data-next]', c), 'click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (dots.length) on(track, 'scroll', debounce(function () { var i = Math.round(track.scrollLeft / step()); dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }, 60), { passive: true });
    // Arrows fade at the ends of the row
    var pb = $('[data-prev]', c), nb = $('[data-next]', c);
    function ends() {
      var max = track.scrollWidth - track.clientWidth - 2;
      c.classList.toggle('is-static', max <= 0);
      if (pb) pb.classList.toggle('is-off', track.scrollLeft <= 2);
      if (nb) nb.classList.toggle('is-off', track.scrollLeft >= max);
    }
    on(track, 'scroll', debounce(ends, 60), { passive: true }); on(window, 'resize', debounce(ends, 150)); ends();
    /* Auto-rotate: pauses while hovered (mouse), for 8 s after a touch, swipe or click, and while off screen */
    var auto = parseFloat(c.getAttribute('data-autoplay'));
    if (auto > 0) {
      var hold = 0, seen = true, canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      var touch = function () { hold = Date.now() + 8000; };
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { on(c, ev, touch, { passive: true }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }).observe(c);
      c._t = setInterval(function () {
        if (!seen || document.hidden || Date.now() < hold || (canHover && c.matches(':hover'))) return;
        var max = track.scrollWidth - track.clientWidth - 4; if (max <= 0) return;
        track.scrollTo({ left: track.scrollLeft >= max ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
      }, auto * 1000);
    }
  }
  T.initCarousel = initCarousel;

  /* ---------- Tabs (sliding underline, smooth height and fade) ---------- */
  var EASE = 'cubic-bezier(.16, 1, .3, 1)';
  function reduceMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function initTabs(tabs) {
    if (!once(tabs, 'tabs')) return;
    var btns = $$('[role="tab"]', tabs).filter(function (b) { return b.closest('[data-tabs]') === tabs; });
    if (!btns.length) return;
    var nav = btns[0].parentElement, ink = $('.tabs__ink', nav);
    function panelOf(b) { return document.getElementById(b.getAttribute('aria-controls')); }
    function moveInk(b) { if (!ink || !b) return; ink.style.setProperty('--x', b.offsetLeft + 'px'); ink.style.setProperty('--w', b.offsetWidth + 'px'); ink.classList.add('is-ready'); }
    function select(i, focus) {
      var cur = -1;
      btns.forEach(function (b, j) { if (b.getAttribute('aria-selected') === 'true') cur = j; });
      var h0 = tabs.offsetHeight;
      btns.forEach(function (b, j) {
        var onn = i === j;
        b.setAttribute('aria-selected', onn ? 'true' : 'false'); b.tabIndex = onn ? 0 : -1;
        var p = panelOf(b); if (p) p.hidden = !onn;
      });
      moveInk(btns[i]);
      if (focus) btns[i].focus();
      var np = panelOf(btns[i]);
      if (cur === i || cur < 0 || !np || reduceMotion() || !tabs.animate) return;
      var h1 = tabs.offsetHeight;
      if (Math.abs(h1 - h0) > 1) {
        tabs.style.overflow = 'hidden';
        var a = tabs.animate({ height: [h0 + 'px', h1 + 'px'] }, { duration: 460, easing: EASE });
        a.onfinish = a.oncancel = function () { tabs.style.overflow = ''; };
      }
      var dir = i > cur ? 1 : -1;
      np.animate([{ opacity: 0, transform: 'translateX(' + (22 * dir) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 480, easing: EASE });
    }
    btns.forEach(function (b, i) {
      on(b, 'click', function () { select(i); });
      on(b, 'keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % btns.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + btns.length) % btns.length, true); }
      });
    });
    var first = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || btns[0];
    requestAnimationFrame(function () { moveInk(first); });
    on(window, 'resize', debounce(function () { moveInk(btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0]); }, 150));
  }

  /* ---------- Collapsible rows (any <details>): smooth open and close ---------- */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('summary'); if (!sum) return;
    var d = sum.parentElement;
    if (!d || d.tagName !== 'DETAILS' || d.hasAttribute('data-no-anim') || reduceMotion() || !d.animate) return;
    e.preventDefault();
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    var start = d.offsetHeight, end;
    d.style.overflow = 'hidden';
    if (d.open) {
      d.open = false; end = d.offsetHeight; d.open = true;
      d.classList.add('is-closing');
      d._anim = d.animate({ height: [start + 'px', end + 'px'] }, { duration: 380, easing: EASE });
      d._anim.onfinish = function () { d.open = false; d.classList.remove('is-closing'); d.style.overflow = ''; d._anim = null; };
    } else {
      d.open = true; end = d.offsetHeight;
      d._anim = d.animate({ height: [start + 'px', end + 'px'] }, { duration: 460, easing: EASE });
      $$(':scope > :not(summary)', d).forEach(function (c) { c.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 60, easing: EASE, fill: 'backwards' }); });
      d._anim.onfinish = function () { d.style.overflow = ''; d._anim = null; };
    }
  });

  /* ---------- Colour swatches that slide to their photo ---------- */
  function initSwatchSlider(el) {
    if (!once(el, 'swatches')) return;
    var track = $('[data-track]', el), btns = $$('[data-swatch-go]', el), nameEl = $('[data-swatch-name]', el);
    if (!track || !btns.length) return;
    var slides = Array.prototype.slice.call(track.children);
    function setActive(i) {
      btns.forEach(function (b, j) { b.classList.toggle('is-active', i === j); b.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
      if (nameEl) { var n = slides[i] && slides[i].getAttribute('data-slide-name'); nameEl.textContent = n || ''; }
    }
    btns.forEach(function (b) {
      on(b, 'click', function () {
        var i = parseInt(b.getAttribute('data-swatch-go'), 10);
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' });
        setActive(i);
      });
    });
    var t;
    on(track, 'scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); setActive(Math.max(0, Math.min(slides.length - 1, i))); }, 80);
    }, { passive: true });
    setActive(0);
  }

  /* ---------- Click and drag to scroll rows (desktop mouse) ---------- */
  function initDrag(el) {
    if (!el || !once(el, 'drag') || !window.matchMedia('(pointer: fine)').matches) return;
    var down = false, moved = false, x0 = 0, s0 = 0, lastX = 0, lastT = 0, v = 0;
    el.classList.add('is-draggable');
    on(el, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || el.scrollWidth <= el.clientWidth + 2) return;
      if (e.target.closest('input, select, textarea, label, [data-qa-btn], [data-qa-size], .qa')) return;
      down = true; moved = false; x0 = lastX = e.clientX; s0 = el.scrollLeft; lastT = Date.now(); v = 0;
    });
    on(window, 'pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 6) { moved = true; el.classList.add('is-dragging'); }
      if (!moved) return;
      var now = Date.now(); v = (e.clientX - lastX) / Math.max(1, now - lastT); lastX = e.clientX; lastT = now;
      el.scrollLeft = s0 - dx;
    });
    on(window, 'pointerup', function () {
      if (!down) return; down = false;
      if (!moved) return;
      var target = el.scrollLeft - v * 220;
      var kids = Array.prototype.slice.call(el.children).filter(function (k) { return k.offsetWidth > 0; });
      var er = el.getBoundingClientRect(), pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || parseFloat(getComputedStyle(el).paddingLeft) || 0;
      var centre = kids[0] && /center/.test(getComputedStyle(kids[0]).scrollSnapAlign);
      var best = target, bd = Infinity;
      kids.forEach(function (k) {
        var kr = k.getBoundingClientRect(), left = el.scrollLeft + kr.left - er.left;
        var pos = centre ? left - (el.clientWidth - kr.width) / 2 : left - pad;
        var dd = Math.abs(pos - target); if (dd < bd) { bd = dd; best = pos; }
      });
      el.classList.remove('is-dragging');
      el.scrollTo({ left: Math.max(0, best), behavior: 'smooth' });
      setTimeout(function () { moved = false; }, 0);
    });
    on(el, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    on(el, 'dragstart', function (e) { if (e.target.tagName === 'IMG' || e.target.tagName === 'A') e.preventDefault(); });
  }
  T.initDrag = initDrag;
  T.initTabs = initTabs;

  /* ---------- Videos ---------- */
  function initVideo(v) {
    if (!once(v, 'vid')) return;
    v.muted = true; v.playsInline = true;
    if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
    new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: 0.2 }).observe(v);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-popup]');
    if (!b) return;
    e.preventDefault();
    var m = $('#VideoModal');
    if (!m) {
      m = document.createElement('div'); m.id = 'VideoModal'; m.className = 'modal'; m.setAttribute('aria-hidden', 'true');
      m.innerHTML = '<div class="drawer__overlay" data-close></div><div class="modal__panel" role="dialog" aria-modal="true" style="--modal-w:960px;padding:0;background:#000"><button type="button" class="icon-btn" data-close aria-label="' + String((T.strings && T.strings.close) || 'Close').replace(/"/g, '&quot;') + '" style="color:#fff;z-index:2">✕</button><div data-video-slot style="aspect-ratio:16/9"></div></div>';
      document.body.appendChild(m);
      on(m, 'panel:close', function () { $('[data-video-slot]', m).innerHTML = ''; });
    }
    var tpl = b.closest('.sec') && $('template[data-video-tpl]', b.closest('.sec'));
    $('[data-video-slot]', m).innerHTML = tpl ? tpl.innerHTML : '';
    var host = b.closest('[data-sound]'); m.setAttribute('data-sound', host ? host.getAttribute('data-sound') : 'true');
    var vid = $('video', m); if (vid) { vid.muted = !soundOn(m); vid.play().catch(function () {}); }
    openPanel(m, b);
  });
  /* ---------- Master sound (Theme settings > Videos) ---------- */
  /* Sound is set per section or block (data-sound="false" keeps its videos silent, even when tapped) */
  function soundOn(el) { var h = el && el.closest && el.closest('[data-sound]'); return !h || h.getAttribute('data-sound') !== 'false'; }
  document.addEventListener('volumechange', function (e) { if (e.target.tagName === 'VIDEO' && !e.target.muted && !soundOn(e.target)) e.target.muted = true; }, true);
  document.addEventListener('play', function (e) { if (e.target.tagName === 'VIDEO' && !soundOn(e.target)) e.target.muted = true; }, true);

  /* ---------- Video rows: short previews one after another ----------
     data-play="preview": each video plays silently for data-seconds, then the next one starts (back to the first after the last).
     A "Continue playing" button and a countdown bar show during the preview. Tapping a video plays it in full.
     data-play="all": every video plays silently while on screen. data-play="tap": nothing plays until tapped. */
  function initVideoRow(row) {
    if (!once(row, 'vrow')) return;
    var items = $$('[data-ugc]', row).filter(function (it) { return $('video', it); });
    if (!items.length) return;
    var mode = row.getAttribute('data-play') || 'preview';
    var secs = Math.max(1, parseFloat(row.getAttribute('data-seconds')) || 4);
    var track = $('[data-track]', row) || row;
    var idx = 0, timer = null, visible = false, full = null;
    items.forEach(function (it) { var v = $('video', it); v.muted = true; v.playsInline = true; v.loop = false; v.removeAttribute('controls'); v.style.setProperty('--pv', secs + 's'); it.style.setProperty('--pv', secs + 's'); });
    function vid(it) { return $('video', it); }
    function stopPreview(it) {
      if (!it) return;
      it.classList.remove('is-preview', 'is-counting');
      var v = vid(it); if (!full || full !== it) { v.pause(); }
    }
    function keepInView(it) {
      if (track.scrollWidth <= track.clientWidth + 2) return;
      var tr = track.getBoundingClientRect(), r = it.getBoundingClientRect();
      if (r.left < tr.left - 2 || r.right > tr.right + 2) track.scrollTo({ left: track.scrollLeft + r.left - tr.left - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: 'smooth' });
    }
    function preview(i) {
      clearTimeout(timer);
      items.forEach(function (it) { if (it !== full) stopPreview(it); });
      if (full || !visible) return;
      idx = (i + items.length) % items.length;
      var it = items[idx], v = vid(it);
      v.muted = true;
      try { v.currentTime = 0; } catch (e) {}
      it.classList.add('is-preview');
      keepInView(it);
      var started = false;
      function start() {
        if (started || !it.classList.contains('is-preview')) return; started = true;
        it.classList.remove('is-counting'); void it.offsetWidth; it.classList.add('is-counting');
        timer = setTimeout(function () { preview(idx + 1); }, secs * 1000);
      }
      v.addEventListener('playing', start, { once: true });
      v.play().catch(function () { start(); });
      setTimeout(start, 1500); // never wait forever on a slow video
    }
    function playFull(it) {
      clearTimeout(timer);
      items.forEach(function (o) { if (o !== it) { stopPreview(o); o.classList.remove('is-playing', 'is-paused'); vid(o).pause(); } });
      full = it;
      var v = vid(it);
      it.classList.remove('is-preview', 'is-counting', 'is-paused');
      it.classList.add('is-playing');
      v.muted = !soundOn(it);
      v.play().catch(function () { v.muted = true; v.play().catch(function () {}); });
    }
    items.forEach(function (it) {
      var v = vid(it);
      on(it, 'click', function (e) {
        e.preventDefault();
        if (full === it && !v.paused) { v.pause(); it.classList.add('is-paused'); return; }
        playFull(it);
      });
      on(v, 'ended', function () {
        if (full === it) { full = null; it.classList.remove('is-playing', 'is-paused'); if (mode === 'preview') preview(items.indexOf(it) + 1); }
        else if (mode === 'all') { v.currentTime = 0; v.play().catch(function () {}); }
      });
    });
    if (mode === 'tap' || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        visible = en.isIntersecting;
        if (mode === 'all') { items.forEach(function (it) { var v = vid(it); if (it === full) return; if (visible) { v.muted = true; v.play().catch(function () {}); it.classList.add('is-auto'); } else v.pause(); }); return; }
        if (visible) { if (!full) preview(idx); }
        else { clearTimeout(timer); items.forEach(function (it) { stopPreview(it); }); if (full) { vid(full).pause(); full.classList.add('is-paused'); } }
      });
    }, { threshold: 0.35 }).observe(row);
  }
  T.initVideoRow = initVideoRow;


  /* ---------- Slideshow / hero ---------- */
  function initSlideshow(el) {
    if (!once(el, 'ss')) return;
    var slides = $$('[data-slide]', el); if (slides.length < 2) return;
    var dots = $$('[data-go]', el), i = 0, t, ms = (parseInt(el.getAttribute('data-autoplay'), 10) || 0) * 1000;
    function go(n) {
      slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active');
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      var v = $('video', slides[i]); if (v) v.play().catch(function () {});
    }
    function play() { clearInterval(t); if (ms) t = setInterval(function () { if (!el.matches(':hover')) go(i + 1); }, ms); }
    dots.forEach(function (d) { on(d, 'click', function () { go(+d.getAttribute('data-go')); play(); }); });
    on($('[data-prev]', el), 'click', function () { go(i - 1); play(); });
    on($('[data-next]', el), 'click', function () { go(i + 1); play(); });
    var x0 = null;
    on(el, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(el, 'touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) { go(i + (dx < 0 ? 1 : -1)); play(); } x0 = null; });
    play();
    el._go = go;
  }
  document.addEventListener('shopify:block:select', function (e) {
    var ss = e.target.closest && e.target.closest('[data-slideshow]');
    if (ss && ss._go) ss._go($$('[data-slide]', ss).indexOf(e.target));
  });

  /* ---------- Product recommendations & recently viewed ---------- */
  function initReco(el) {
    if (!once(el, 'reco')) return;
    var inner = $('[data-reco-inner]', el);
    if (el.getAttribute('data-reco') === 'recent') {
      var cur = el.getAttribute('data-current');
      var list = (store('foundry-recent') || []).filter(function (h) { return h !== cur; }).slice(0, parseInt(el.getAttribute('data-limit'), 10) || 4);
      if (!list.length) { if (!(window.Shopify && window.Shopify.designMode)) el.closest('.shopify-section').hidden = true; return; }
      Promise.all(list.map(function (h) { return fetch(rootUrl() + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (ps) {
          var html = ps.filter(Boolean).map(function (p) {
            var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
            return '<li><div class="pcard"><div class="rel"><a class="pcard__media" href="' + p.url + '" tabindex="-1">' + (img ? '<img class="img-1" src="' + img + '" alt="" loading="lazy" width="600" height="800">' : '') + '</a></div><div class="pcard__info"><a class="pcard__title" href="' + p.url + '">' + p.title + '</a><span class="pcard__price price"><span>' + formatMoney(p.price) + '</span>' + (p.compare_at_price > p.price ? '<s>' + formatMoney(p.compare_at_price) + '</s>' : '') + '</span></div></div></li>';
          }).join('');
          if (html) { inner.innerHTML = html; el.hidden = false; }
        });
      return;
    }
    var url = el.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html'), fresh = $('[data-reco-inner]', d);
      if (fresh && fresh.children.length) { inner.innerHTML = fresh.innerHTML; el.hidden = false; $$('.pcard', inner).forEach(updateQuickSizes); }
      else if (!(window.Shopify && window.Shopify.designMode)) el.closest('.shopify-section').hidden = true;
    }).catch(function () {});
  }

  /* ---------- Newsletter pop-up ---------- */
  function initPopup(p) {
    if (!once(p, 'popup')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var key = 'foundry-popup-' + (p.getAttribute('data-key') || '1');
    var days = parseInt(p.getAttribute('data-days'), 10) || 7;
    var seen = store(key);
    if (seen && Date.now() - seen < days * 864e5) return;
    if (p.hasAttribute('data-posted')) { openPanel(p); return; }
    var shown = false;
    function show() { if (shown || stack.length) return; shown = true; store(key, Date.now()); openPanel(p); }
    setTimeout(show, (parseInt(p.getAttribute('data-delay'), 10) || 8) * 1000);
    if (p.hasAttribute('data-exit')) on(document, 'mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }

  /* ---------- Misc ---------- */
  function initMisc() {
    // Tab attention
    if (T.settings.tabMessage) {
      var title = document.title;
      on(document, 'visibilitychange', function () { document.title = document.hidden ? T.settings.tabMessage : title; });
    }
    // External links
    if (T.settings.externalNewTab) $$('a[href^="http"]').forEach(function (a) { if (a.hostname && a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noopener'; } });
    // Preload on hover
    if (T.settings.preload && 'relList' in document.createElement('link')) {
      var done = {};
      on(document, 'mouseover', function (e) {
        var a = e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hostname !== location.hostname) return;
        var u = a.href.split('#')[0]; if (done[u] || u === location.href.split('#')[0] || /\/(cart|checkout|account)/.test(a.pathname)) return;
        done[u] = 1; var l = document.createElement('link'); l.rel = 'prefetch'; l.href = u; document.head.appendChild(l);
      }, { passive: true });
    }
    // Page transition
    if (document.body.hasAttribute('data-page-transition')) {
      on(document, 'click', function (e) {
        var a = e.target.closest('a[href]');
        if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || a.target === '_blank' || a.hostname !== location.hostname || a.getAttribute('href').charAt(0) === '#' || a.hasAttribute('download')) return;
        e.preventDefault(); document.body.classList.add('is-leaving');
        setTimeout(function () { window.location.href = a.href; }, 220);
      });
      on(window, 'pageshow', function (e) { if (e.persisted) document.body.classList.remove('is-leaving'); });
    }
    // Back to top
    var tt = $('[data-to-top]');
    if (tt) { on(window, 'scroll', debounce(function () { tt.classList.toggle('is-on', window.scrollY > 900); }, 80), { passive: true }); on(tt, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }); }
  }

  /* ---------- Init ---------- */
  /* ---------- Icons by name: the "Or any icon" box (Phosphor or Tabler, loaded from jsDelivr) ---------- */
  var ICO_PH = 'https://cdn.jsdelivr.net/npm/@phosphor-icons/core@2.1.1/assets/', ICO_TI = 'https://cdn.jsdelivr.net/npm/@tabler/icons@3.48.0/icons/', icoCache = {};
  function icoParse(raw) {
    var s = String(raw || '').trim(), lib = '', m, toks;
    if ((m = s.match(/icon-tabler-([a-z0-9-]+)/i)) || (m = s.match(/\bti-([a-z0-9-]+)/i))) return { lib: 'ti', n: m[1].toLowerCase() };
    toks = (s.match(/\bph-[a-z0-9-]+/gi) || []).map(function (t) { return t.slice(3).toLowerCase(); }).filter(function (t) { return !/^(thin|light|regular|bold|fill|duotone)$/.test(t); });
    if (toks.length) return { lib: 'ph', n: toks[0] };
    if ((m = s.match(/^(ph|phosphor|ti|tabler)\s*[:\/]\s*(.+)$/i))) { lib = /^ph/i.test(m[1]) ? 'ph' : 'ti'; s = m[2]; }
    if ((m = s.match(/<\s*([A-Z][A-Za-z0-9]*)/))) s = m[1];
    if (/^Icon[A-Z0-9]/.test(s)) { lib = 'ti'; s = s.slice(4); } else if (/^Ph[A-Z]/.test(s)) { lib = 'ph'; s = s.slice(2); }
    s = s.replace(/[<>\/"'{}=]/g, ' ').trim().replace(/\s+/g, '-');
    if (/[A-Z]/.test(s) && /[a-z]/.test(s)) s = s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([a-z])([0-9])/g, '$1-$2');
    s = s.toLowerCase().replace(/_/g, '-').replace(/[^a-z0-9-]/g, '');
    if (lib !== 'ti') s = s.replace(/-(thin|light|bold|fill|duotone)$/, '');
    return { lib: lib, n: s };
  }
  function icoUrls(p, w) {
    var ph = [ICO_PH + w + '/' + p.n + (w === 'regular' ? '' : '-' + w) + '.svg'];
    var ti = w === 'fill' ? [ICO_TI + 'filled/' + p.n + '.svg', ICO_TI + 'outline/' + p.n + '.svg'] : [ICO_TI + 'outline/' + p.n + '.svg'];
    return p.lib === 'ti' ? ti.concat(ph) : ph.concat(ti);
  }
  function icoFetch(urls) {
    var key = urls[0];
    if (icoCache[key]) return icoCache[key];
    try { var c = sessionStorage.getItem('ico:' + key); if (c) return (icoCache[key] = Promise.resolve(c)); } catch (e) {}
    var i = 0;
    function next() {
      if (i >= urls.length) return Promise.reject(new Error('icon not found'));
      return fetch(urls[i++]).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (t) { if (t.indexOf('<svg') < 0) throw 0; return t; }).catch(next);
    }
    return (icoCache[key] = next().then(function (t) { try { sessionStorage.setItem('ico:' + key, t); } catch (e) {} return t; }));
  }
  function initIcons(scope) {
    $$('[data-ico-name]:not([data-ico-done])', scope).forEach(function (el) {
      el.setAttribute('data-ico-done', '1');
      var p = icoParse(el.getAttribute('data-ico-name')); if (!p.n) return;
      icoFetch(icoUrls(p, el.getAttribute('data-ico-w') || 'light')).then(function (t) {
        var svg = new DOMParser().parseFromString(t, 'image/svg+xml').documentElement;
        if (!svg || svg.nodeName.toLowerCase() !== 'svg') return;
        $$('script, foreignObject', svg).forEach(function (n) { n.parentNode.removeChild(n); });
        [svg].concat($$('*', svg)).forEach(function (n) { Array.prototype.slice.call(n.attributes).forEach(function (a) { if (/^on/i.test(a.name) || /javascript:/i.test(a.value)) n.removeAttribute(a.name); }); });
        svg.removeAttribute('width'); svg.removeAttribute('height');
        svg.setAttribute('class', el.getAttribute('class').replace('ico--ext', 'ico--svg'));
        svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
        if (el.parentNode) el.parentNode.replaceChild(document.importNode(svg, true), el);
      }).catch(function () {});
    });
  }

  /* ---------- Rotating quotes (CS Quote strip) ---------- */
  function initQrot(el) {
    if (!once(el, 'qrot')) return;
    var slides = $$('.qrot__slide', el);
    if (slides.length < 2) { el.classList.add('is-single'); return; }
    var ms = parseInt(el.getAttribute('data-ms'), 10) || 4500, i = 0, t = null, left = ms, start = 0;
    var rate = $('[data-rate]', el), badge = $('.qrot__rate', el), count = $('[data-count]', el), dots = $$('.qrot__dots i', el), line = $('.qrot__line i', el);
    var why = {}, canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function paused() { for (var k in why) if (why[k]) return true; return false; }
    function schedule() { clearTimeout(t); if (paused()) return; start = Date.now(); t = setTimeout(function () { show(i + 1); }, left); }
    function hold(k, onn) {
      var was = paused(); why[k] = onn; var now = paused();
      el.classList.toggle('is-paused', now);
      if (now && !was) { clearTimeout(t); left = Math.max(250, left - (Date.now() - start)); }
      else if (!now && was) schedule();
    }
    function show(n, first) {
      var prev = i; i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        s.classList.toggle('is-out', !first && k === prev && prev !== i);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      setTimeout(function () { slides.forEach(function (s, k) { if (k !== i) s.classList.remove('is-out'); }); }, 700);
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (count) count.textContent = i + 1;
      if (rate) {
        var r = slides[i].getAttribute('data-rating') || '';
        if (badge) badge.hidden = !r;
        if (rate.textContent !== r) rate.textContent = r;
        if (!first && badge) { badge.classList.remove('is-pop'); void badge.offsetWidth; badge.classList.add('is-pop'); }
      }
      if (line) { line.classList.remove('is-run'); void line.offsetWidth; line.classList.add('is-run'); }
      left = ms; schedule();
    }
    if (el.getAttribute('data-tap') === 'true') {
      var held = false, ht;
      on(el, 'click', function () { if (held) { held = false; return; } show(i + 1); });
      on(el, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i + 1); } });
      on(el, 'pointerdown', function () { ht = setTimeout(function () { held = true; hold('press', true); }, 350); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { on(el, ev, function () { clearTimeout(ht); hold('press', false); }); });
    }
    if (canHover) { on(el, 'mouseenter', function () { hold('hover', true); }); on(el, 'mouseleave', function () { hold('hover', false); }); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { hold('view', !es[0].isIntersecting); }).observe(el);
    on(document, 'visibilitychange', function () { hold('tab', document.hidden); });
    /* Theme editor: selecting a quote shows it and holds it */
    on(document, 'shopify:block:select', function (e) { var k = slides.indexOf(e.target); if (k > -1) { show(k); hold('editor', true); } });
    on(document, 'shopify:block:deselect', function (e) { if (slides.indexOf(e.target) > -1) hold('editor', false); });
    show(0, true);
  }

  /* ---------- Content protection (Theme settings) ---------- */
  (function protect() {
    var h = document.documentElement, rc = h.hasAttribute('data-protect-rc'), md = h.hasAttribute('data-protect-media');
    if (!rc && !md) return;
    var media = 'img, video, picture, canvas, [data-media], .gallery, .zoom-modal';
    document.addEventListener('contextmenu', function (e) { if (rc || (e.target.closest && e.target.closest(media))) e.preventDefault(); }, true);
    if (!md) return;
    document.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest('img, video, picture')) e.preventDefault(); }, true);
    document.addEventListener('keydown', function (e) { if ((e.ctrlKey || e.metaKey) && String(e.key).toLowerCase() === 's') e.preventDefault(); }, true);
    function lock(scope) {
      (scope.tagName === 'VIDEO' ? [scope] : $$('video', scope)).forEach(function (v) {
        v.setAttribute('controlsList', 'nodownload'); v.setAttribute('disablePictureInPicture', ''); v.setAttribute('disableRemotePlayback', '');
      });
    }
    function start() {
      lock(document);
      if (window.MutationObserver) new MutationObserver(function (list) { list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) lock(n); }); }); }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  })();

  function init(scope) {
    scope = scope || document;
    initIcons(scope);
    $$('[data-qrot]', scope).forEach(initQrot);
    initHeader(); initSearch();
    $$('[data-announce-slider]', scope).forEach(initAnnouncement);
    $$('.drawer', scope).forEach(initSwipe);
    $$('[data-carousel]', scope).forEach(initCarousel);
    $$('[data-tabs]', scope).forEach(initTabs);
    $$('[data-swatch-slider]', scope).forEach(initSwatchSlider);
    $$('[data-track], .ugc__row, .addons, .gallery__track', scope).forEach(initDrag);
    $$('video[data-autoplay]', scope).forEach(initVideo);
    $$('[data-video-row]', scope).forEach(initVideoRow);
    $$('video[autoplay]', scope).forEach(initVideo);
    $$('[data-slideshow]', scope).forEach(initSlideshow);
    $$('[data-reco]', scope).forEach(initReco);
    $$('[data-popup]', scope).forEach(initPopup);
    $$('.pcard', scope).forEach(updateQuickSizes);
    initAnimations(scope);
    if (scope === document) { initCartUI($('#CartDrawer')); initCartUI($('[data-cart-page]')); initMisc(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if ($('#CartDrawer', e.target)) initCartUI($('#CartDrawer')); });
  document.addEventListener('shopify:section:select', function (e) {
    var d = $('.drawer, .modal', e.target);
    if (d && (d.id === 'CartDrawer' || d.hasAttribute('data-popup'))) openPanel(d);
    $$('.rv, .rv-stagger, [data-split], .rv-img', e.target).forEach(function (x) { x.classList.add('is-in'); });
  });
  document.addEventListener('shopify:section:deselect', function (e) { var d = $('.drawer.is-open, .modal.is-open', e.target); if (d) closePanel(d); });
})();
